import React, { Component } from 'react'
import Simplefooter from '../footer/simplefooter'
import data from '../../mock/workshops-mock.json'
import YouTube from 'react-youtube'
import "./style.css"
//  Importa os vídeos, observe que há um vídeo que o índice não funciona,
//  desse modo, o vídeo 4(Togaf) está desativado, de modo que estou pulando
//  o mesmo.
// import videoOne from '../../assets/media/bitcoin_blockchain.mp4'
// import videoTwo from '../../assets/media/arquitetura_integracao.mp4'
// import videoThree from '../../assets/media/implementacao_microservices.mp4'
// import videoFive from '../../assets/media/business_trends.mp4'
// import videoSix from '../../assets/media/inteligencia_competitiva.mp4'
// import videoSeven from '../../assets/media/api_for_business.mp4'
// import videoEight from '../../assets/media/a_comerce.mp4'
// import videoNine from '../../assets/media/arquitetura_blockchain.mp4'
//
import teacherImg from '../../assets/Marcos.jpg'
import iconMone from '../../assets/icons/dollar-sign-solid.svg'
//Novos ícones
import iconClock from '../../assets/icons/time.png'

import mul1 from '../../assets/banners/courses/Data_Bitcoin.png'
import mob1 from '../../assets/banners/courses/Workshop_Bitcoin.png'

import mul2 from '../../assets/banners/courses/Datas_Arqui._Integracao.png'
import mob2 from '../../assets/banners/courses/Workshop_Arqui._Integracao.png'

import mul3 from '../../assets/banners/courses/Bnner_Data_Implementacao_de_Microservices.png'
import mob3 from '../../assets/banners/courses/Workshop_Implementacao_de_Microservices.png'

import mul4 from '../../assets/Curso_img/splint/Banner_Togaf.png'
// import mob4 from '../../assets/Curso_img/splint/Mobile_Togaf.png'

import mul5 from '../../assets/banners/courses/Data_Business_Trends.png'
import mob5 from '../../assets/banners/courses/Workshop_Business_Trends.png'

import mul6 from '../../assets/banners/courses/Data_Inteligencia_Competitiva.png'
import mob6 from '../../assets/banners/courses/Workshop_Inteligencia_Competitiva.png'

import mul7 from '../../assets/banners/courses/ApiForBusiness/datasAPI.png'
import mob7 from '../../assets/banners/courses/ApiForBusiness/mobile workshop.png'

import mul8 from '../../assets/banners/courses/Datas_A_COMMERCE.png'
import mob8 from '../../assets/banners/courses/Workshop_A_COMMERCE.png'

import mul9 from '../../assets/Curso_img/splint/Banner_Blockchain.png'
import mob9 from '../../assets/Curso_img/splint/Mobile_Blockchain.png'

import mul12 from "../../assets/banners/courses/Data_COMO_MONTAR_SUA_STARTUP.png";
import mob12 from "../../assets/banners/courses/Mobile_Carrosel_e_Workshop_COMO_MONTAR_SUA_STARTUP.png";  

import mul13 from "../../assets/banners/courses/Cloud/Banner_cloud.png";
import mob13 from "../../assets/banners/courses/Cloud/mobile_cloud.png";

import mul14 from "../../assets/banners/courses/Datas_Cybersecurity_com_Solucoes_Open_Source.png";
import mob14 from "../../assets/banners/courses/Mobile_Carrosel_e_Workshop_Cybersecurity_com_Solucoes_Open_Source.png";

import mul15 from "../../assets/banners/courses/dataAnalytics/Data_DATA_ANALYTICS_DOS_DADOS_AOS_INSIGTHS.png";
import mob15 from "../../assets/banners/courses/dataAnalytics/Mobile_DATA_ANALYTICS_DOS_DADOS_AOS_INSIGTHS.png";

import mul16 from "../../assets/banners/courses/aplicMoveis/Datas_DESENVOLVIMENTO_APLICACOES_MOVEIS.png";
import mob16 from "../../assets/banners/courses/aplicMoveis/Mobile_Carrosel_e_Workshop_DESENVOLVIMENTO_APLICACOES_MOVEIS.png";


import mul17 from "../../assets/banners/courses/chatbot/Datas_DESEN._CHATBOTS_AMB._CORPORATIVOS.png";
import mob17 from "../../assets/banners/courses/aplicMoveis/Mobile_Carrosel_e_Workshop_DESENVOLVIMENTO_APLICACOES_MOVEIS.png";

import mul18 from '../../assets/banners/courses/DesenvolvimentoTI/banner_desenvolvimento_ti.png'
import mob18 from '../../assets/banners/courses/DesenvolvimentoTI/banner_workshopDesenvolvimentoTI.png'

import mul19 from '../../assets/banners/courses/arquiDesenBlockchain/Data_ARQUI._E_DESEN._EM_BLOCKCHAIN.png'
import mob19 from '../../assets/banners/courses/arquiDesenBlockchain/Workshop_ARQUI._E_DESEN._EM_BLOCKCHAIN.png'

import mul20 from "../../assets/banners/courses/AplJogos/Data_APLICACOES_EJOGOS-09.png";
import mob20 from "../../assets/banners/courses/AplJogos/Data_APLICACOES_EJOGOS-09.png";

import mul21 from "../../assets/banners/courses/dashboardAnalytics/PC_Workshop_e_Data_DASHBOARD_E_ANALYTICS.png";
import mob21 from "../../assets/banners/courses/dashboardAnalytics/Mobile_Data_DASHBOARD_E_ANALYTICS.png";

import mul22 from "../../assets/banners/courses/designThings/Data_DESIGN_THINKING (1).png";
import mob22 from "../../assets/banners/courses/designThings/Workshop_DESIGN_THINKING.png";

import mul23 from "../../assets/banners/courses/InternetOfThings/Data_INTERNET_OF_THING_E_SENSORIZACAO.png";
import mob23 from "../../assets/banners/courses/InternetOfThings/Mobile_Carrosel_INTERNET_OF_THING_E_SENSORIZACAO (1).png";

import mul24 from '../../assets/banners/courses/desenvolvendoApis/workshop_data_pc.png'
import mob24 from '../../assets/banners/courses/desenvolvendoApis/workshop_data_pc.png'

import mul25 from "../../assets/banners/courses/Intel_em_Cybersecurity/PC_Data.png";
import mob25 from "../../assets/banners/courses/Intel_em_Cybersecurity/Mobile_Data_INTELIGENCIA_EM_CYBERSECURITY_COM_SOLUCOES_OPEN_SOURCE-13.png";

import mul26 from "../../assets/banners/courses/NoSQL/Banner_NOSQL.png";
import mob26 from "../../assets/banners/courses/NoSQL/Mobile_NOSQL.png";

import mul27 from "../../assets/banners/courses/Storytelling/PC_Data_STORYTELLING_E_UX_PARA_NEGOCIOS.png";
import mob27 from "../../assets/banners/courses/Storytelling/Mobile_Data_STORYTELLING_E_UX_PARA_NEGOCIOS-13.png";

import mul28 from "../../assets/banners/courses/APIGATEWAY/PC_Workshop_API_GATEWAY.png";
import mob28 from "../../assets/banners/courses/APIGATEWAY/Mobile_Data_API_GATEWAY.png";

import mul29 from "../../assets/banners/courses/agilidade/PC_Data_AGILIDADE_DEVOPS_E_PERFORMANCE_EM_TI.png";
import mob29 from "../../assets/banners/courses/agilidade/Mobile_Data_AGILIDADE_DEVOPS_E_PERFORMANCE_EM_TI-13.png";

import mul30 from "../../assets/banners/courses/acoes/Data_COMO_INVESTIR_EM_ACOES_DE_FORMA_SEGURA.png";
import mob30 from "../../assets/banners/courses/acoes/Mobile_Workshop_COMO_INVESTIR_EM_ACOES_DE_FORMA_SEGURA.png";

import mul31 from "../../assets/banners/courses/design_sprint/PC_Data_DESIGN_SPRINT.png";
import mob31 from "../../assets/banners/courses/design_sprint/Mobile_Data_DESIGN_SPRINT.png";

import mul32 from "../../assets/banners/courses/ethical hacking/PC_Data_ETHICAL_HACKING_METOLOGIA_DE_PENTEST.png";
import mob32 from "../../assets/banners/courses/ethical hacking/Mobile_Data_ETHICAL_HACKING_METOLOGIA_DE_PENTEST.png";

import mul33 from "../../assets/banners/courses/desenvolvimentoArq/PC_Workshop_DESENVOLVIMENTO_DE_ARQ._DE_INTEG._COM_APACHE_E_KAFKA_SERVICE.png";
import mob33 from "../../assets/banners/courses/desenvolvimentoArq/Mobile_Data_DESENVOLVIMENTO_DE_ARQ._DE_INTEG._COM_APACHE_E_KAFKA_SERVICE.png";

import mul34 from "../../assets/banners/courses/ibm/PC_Workshop_IBM_WATSON_E_CHATBOTS_INTELIGENTES_COM_COGNIFICACAO.png";
import mob34 from "../../assets/banners/courses/ibm/Mobile_Data_IBM_WATSON_E_CHATBOTS_INTELIGENTES_COM_COGNIFICACAO.png";

import mul35 from "../../assets/banners/courses/desWebFullStack/PC_Data_Desenvolvimento_Web_Full_Stack.png";
import mob35 from "../../assets/banners/courses/desWebFullStack/Mobile_Data_Desenvolvimento_Web_Full_Stack.png";

import mul36 from "../../assets/banners/courses/intelCyberEthical/PC_Wokshop_INTELIGENCIA_EM_CYBERSECURITY_COM_ETHICAL_HACKING.png";
import mob36 from "../../assets/banners/courses/intelCyberEthical/Mobile_Workshop_INTELIGENCIA_EM_CYBERSECURITY_COM_ETHICAL_HACKING (1).png";

import mul37 from "../../assets/banners/courses/gestao_proj/PC_Data_GESTÃO_DE_PROJETOS_DE_FORMA_EFICIENTE_EFICAZ_USANDO_PMI.png";
import mob37 from "../../assets/banners/courses/gestao_proj/Mobile_Data_GESTÃO_DE_PROJETOS_DE_FORMA_EFICIENTE_E_EFICAZ_USANDO_PMI.png";

import mul38 from "../../assets/banners/courses/prep_cert/PC_Data_PREPARATÓRIO_PARA_CERTIFICAÇÃO_ITIL_E_COBIT.png";
import mob38 from "../../assets/banners/courses/prep_cert/Mobile_Data_PREPARATÓRIO_PARA_CERTIFICAÇÃO_ITIL_E_COBIT.png";

import mul39 from "../../assets/banners/courses/fundamentos-devops/PC_Workshop_FUNDAMENTOS_DE_DEVOPS.png";
import mob39 from "../../assets/banners/courses/fundamentos-devops/Moible_Data_FUNDAMENTOS_DE_DEVOPS.png";

import mul40 from "../../assets/banners/courses/arq_infra/PC_Data_ARQUITETURA_DE_INFRAESTRUTURA_CORPORATIVA_DE_TI.png";
import mob40 from "../../assets/banners/courses/arq_infra/Mobile_Data_ARQUITETURA_DE_INFRAESTRUTURA_CORPORATIVA_DE_TI.png";

import mul41 from "../../assets/banners/courses/bigData_Mining/PC_Data_e_Wokshop_BIG_DATA_E_DATA_MINING.png";
import mob41 from "../../assets/banners/courses/bigData_Mining/Mobile_Data_BIG_DATA_E_DATA_MINING.png";

import mul42 from "../../assets/banners/courses/governanca/PC_Workshop_GOVERNANCA_CORPORATIVA_E_TI.png";
import mob42 from "../../assets/banners/courses/governanca/Mobile_Data_GOVERNANCA_CORPORATIVA_E_TI.png";

import mul43 from "../../assets/banners/courses/golangdesenv/desc_banner_data_Golang-06.png";
import mob43 from "../../assets/banners/courses/golangdesenv/MobileDataGOLANGDESENDESISTEMASCOMMICROSERVICES.png";

import mul44 from "../../assets/banners/courses/microservice/PCWorkshopeDataMICROSERVICEUSANDOSTREAMINGPARABIGDATAKAFKANODEJSGOGCP.png";
import mob44 from "../../assets/banners/courses/microservice/MobileWorkshopMICROSERVICEUSANDOSTREAMINGPARABIGDATAKAFKANODEJSGOGCP.png";

import mul45 from "../../assets/banners/courses/praticando/PCDataPRATICANDOARQUITETURADEINTEGRAÇÃOCOMAPACHEKAFKASERVICEMESHISTIOAPIEMONGODB.png"
import mob45 from "../../assets/banners/courses/praticando/PCDataPRATICANDOARQUITETURADEINTEGRAÇÃOCOMAPACHEKAFKASERVICEMESHISTIOAPIEMONGODB.png"

import mul46 from "../../assets/banners/courses/arquitetura_neg/PCWorkshopeDataARQUITETURADENEGÓCIOSCONCEITOSEAPLICABILIDADE.png";
import mob46 from "../../assets/banners/courses/arquitetura_neg/MobileDataARQUITETURADENEGÓCIOSCONCEITOSEAPLICABILIDADE.png";

import mul47 from "../../assets/banners/courses/cyberseguranca/PCWorkshopeDataCYBERSEGURANÇAEATAQUESHACKERS.png";
import mob47 from "../../assets/banners/courses/cyberseguranca/MobileDataCYBERSEGURANÇAEATAQUESHACKERS.png";

import mul48 from "../../assets/banners/courses/arquitetodenegocios/bannerarq.png";
import mob48 from "../../assets/banners/courses/arquitetodenegocios/arqmob.png";

import mul49 from "../../assets/banners/courses/dataAnalytics/Card_Data_Analytics.png";
import mob49 from "../../assets/banners/courses/dataAnalytics/CardDataAnalytics.png";

import mul50 from "../../assets/banners/courses/A_Tecnoliga_do_futuro/Banner_a_tecnologia_do_futuro-06.png";
import mob50 from "../../assets/banners/courses/A_Tecnoliga_do_futuro/Mobile_a_tecnologia_do_futuro-13.png";

import mul51 from "../../assets/banners/courses/Governe_sua_empresa/Banner_Governe_sua_empresa_através_dos_padrões_e_boas_práticas_de_ITIL_e_COBIT-06.png";
import mob51 from "../../assets/banners/courses/Governe_sua_empresa/Mobile_Governe_sua_empresa_através_dos_padrões_e_boas_práticas_de_ITIL_e_COBIT.png";

import mul52 from "../../assets/banners/courses/Arqnegicio_conceitos_apllic/Banner_arquitetura_de_negocio.png";
import mob52 from "../../assets/banners/courses/Arqnegicio_conceitos_apllic/Mobile_arquitetura_de_negocio.png";

import mul53 from "../../assets/banners/courses/Archimate/BannnerARCHIMATE.png";
import mob53 from "../../assets/banners/courses/Archimate/MobileARCHIMATE.png";

// importa o footer
import '../footer/footer'


export default class WorkshopPage extends Component {
  constructor() {    
    super()
    this.state = {
      date: new Date(),
      data: [],
      selectedCourse: [],
      selectedCourseIndex: '0'
    }
  }

  componentWillMount() {
    this.setState({
      data: data,
      selectedCourse: this.props.match.params.id,
      selectedCourseIndex: this.props.match.params.index
    })
  }

  getArticle() {
    const data = this.state.data.conteudo
    this.selectedCourseIndex = this.state.selectedCourseIndex

    data.forEach((resp, index) => {
      if (resp[0].index === this.selectedCourseIndex) {
        return this.setArticle(resp)
      }
    })
  }

  setArticle(resp) {
    const selectedCourse = this.state.selectedCourse.split('?')
    resp.forEach((article, index) => {
      if (article.id === selectedCourse[0]) {
        return this.theArticle = article
      }
      this.theArticle = this.theArticle[0]
    })
  }
  renderVideo(article) {
    const url = `/calendar/${article.index}/${article.id}`
    const opts = {
      height: '480',
      width: '100%',
      playerVars: {
        autoplay: 1
      }
    }
    return (
      <div className="boxHeader">
        <div className="videoYoutube">

          <YouTube
            videoId={article.url}
            opts={opts}
            onReady={this._onReady} />
        </div>
        <div className="curseVi">
          <h2 style={{ paddingLeft: "0", paddingRight: "0" }}>{article.title}</h2>
          <div className="grad_curso">
            <div className="box-1">
              <div className="sec-1">
                <img alt="1" src={iconClock} width={50} />
                <div style={{ textAlign: "center", paddingTop: "10px", marginLeft: "10px" }}>
                  <h5>Duração</h5>
                  <p> 4hr </p>
                </div>
              </div>
              <div className="sec-1">
                <img alt="2" src={iconMone} width={50} />
                <div style={{ textAlign: "center", paddingTop: "10px", marginLeft: "10px" }}>
                  <h5>Investimento</h5>
                  <p> 4hr </p>
                </div>
              </div>
            </div>
            <div className="box-2">
              <a target="_blank" href={url} className="button primary-color">
                Reservar já
        </a>
            </div>
          </div>
        </div>
      </div>
    )

  }

  /**
   *
   * Renderiza o botão que redireciona para o local correto, ou seja:
   * Compra de curso || Saiba mais.
   * ---
   * Melhorar a lógica posteriormente
   */

  buttonRender( state, url ) {

    const callSympla = () => {
      if(url === "/calendar/2/C02"){
        const url2c02 = "https://bit.ly/3b8Pt4i";
        return  url2c02
      } else if (url === "/calendar/3/C03"){
        const url3c03 = "https://bit.ly/3bO8nNP";
        return url3c03
      } else if(url === "/calendar/1/C01"){
        const url1c01 = "https://bit.ly/3vmuKke";
        return url1c01
      } else if(url === "/calendar/7/C07"){
        const url7c07 = "https://www.sympla.com.br/play/api-for-business-com-apigee-apache-nifi-streamset-e-dx/1784519?_gl=1*12ner7g*_ga*NTgyNzU1Mzg4LjE2NzA0MjExMjk.*_ga_KXH10SQTZF*MTY3MDQzMDYzNy4yLjEuMTY3MDQzMTI1Ny4wLjAuMA";
        return url7c07
      }
       else {
        return url
      }
    }
    if( state === "Sim" ) {
      return (<a className="buy-button" href={callSympla()}>
                COMPRE AGORA
                <span className="buy-alert">
                  <figure className="alert-icon"></figure>
                  Invista em sua carreira!
                </span>
              </a>)
    }
      else {
        return  (<a className="buy-button" href={url}>
                  COMPRE AGORA
                  <span className="buy-alert">
                    <figure className="alert-icon"></figure>
                    Invista em sua carreira!
                  </span>
                </a>)
      }
  }

  /**
   *  Retorna o vídeo relacionado ao curso.
   *  OBS: Ajustar corretamente, ou seja, melhorar a codificação após seu
   *  funcionamento.
   */

  selectVideo( index ) {

    switch( index ) {
      case '1': //bitcoin
        return "https://www.youtube.com/embed/5gTwE8T9SSA"
   
      case '2': //arquitetura
        return "https://www.youtube.com/embed/THQBDuoqW2U"        
  
      case '3': //implementação 
        return "https://www.youtube.com/embed/elkwwzaM9Wk"

      case '5': // BUSINESS TRENDS
        return "https://www.youtube.com/embed/3MzOBP1CJeE"

      case '6': //INTELIGÊNCIA COMPETITIVA
        return "https://www.youtube.com/embed/8U5JAGzvMBY"

      case '7': //API FOR BUSINESS COM APIGEE,
        return "https://www.youtube.com/embed/oygjBgUEEt4"
 
      case '8': //A-COMMERCE
        return "https://www.youtube.com/embed/aTt3xr6X3x8"
 
      case '9': 
        return ""

      default:
        return null;
    }
  }

  renderArticle(article) {
    var width = window.innerWidth;
    const url = `/calendar/${article.index}/${article.id}`
    const returnImg = (index) => {
      if (index === 1) {
        if (width > 700)
          return <img alt="1" src={mul1} />
        return <img alt="1" src={mob1} />
      } else if (index === 2) {
        if (width > 700)
          return <img alt="2" src={mul2} />
        return <img alt="2" src={mob2} />
      } else if (index === 3) {
        if (width > 700)
          return <img alt="3" src={mul3} />
        return <img alt="3" src={mob3} />
      } else if (index === 4) {
        // if (width > 700)
        return <img alt="4" src={mul4} />
        // return <img alt="4" src={mob4} />
      } else if (index === 5) {
        if (width > 700)
          return <img alt="5" src={mul5} />
        return <img alt="5" src={mob5} />
      } else if (index === 6) {
        if (width > 700)
          return <img alt="6" src={mul6} />
        return <img alt="6" src={mob6} />
      } else if (index === 7) {
        if (width > 700)
          return <img alt="7" src={mul7} />
        return <img alt="7" src={mob7} />
      } else if (index === 8) {
        if (width > 700)
          return <img alt="8" src={mul8} />
        return <img alt="8" src={mob8} />
      } else if (index === 9) {
        if (width > 700)
          return <img alt="9" src={mul9} />
        return <img alt="9" src={mob9} />
      }
      else if (index === 12) {
        if (width > 700)
          return <img alt="12" src={mul12} />
        return <img alt="12" src={mob12} />
      }

      else if (index === 13) {
        if (width > 700)
          return <img alt="13" src={mul13} />
        return <img alt="13" src={mob13} />
      }

      else if (index === 14) {
        if (width > 700)
          return <img alt="14" src={mul14} />
        return <img alt="14" src={mob14} />
      }

      else if (index === 15) {
        if (width > 700)
          return <img alt="15" src={mul15} />
        return <img alt="15" src={mob15} />
      }

      else if (index === 16) {
        if (width > 700)
          return <img alt="16" src={mul16} />
        return <img alt="16" src={mob16} />
      }

      else if (index === 17) {
        if (width > 700)
          return <img alt="17" src={mul17} />
        return <img alt="17" src={mob17} />
      }
      
      else if (index === 18) {
        if (width > 700)
          return <img alt="18" src={mul18} />
        return <img alt="18" src={mob18} />
      }
      else if (index === 19) {
        if (width > 700)
          return <img alt="19" src={mul19} />
        return <img alt="19" src={mob19} />
      }

      else if (index === 20) {
        if (width > 700)
          return <img alt="20" src={mul20} />
        return <img alt="20" src={mob20} />
      }

      else if (index === 21) {
        if (width > 700)
          return <img alt="21" src={mul21} />
        return <img alt="21" src={mob21} />
      }

      else if (index === 22) {
        if (width > 700)
          return <img alt="22" src={mul22} />
        return <img alt="22" src={mob22} />
      }

      else if (index === 23) {
        if (width > 700)
          return <img alt="23" src={mul23} />
        return <img alt="23" src={mob23} />
      }

      else if (index === 24) {
        if (width > 700)
          return <img alt="24" src={mul24} />
        return <img alt="24" src={mob24} />
      }

      else if (index === 25) {
        if (width > 700)
          return <img alt="25" src={mul25} />
        return <img alt="25" src={mob25} />
      }

      else if (index === 26) {
        if (width > 700)
          return <img alt="26" src={mul26} />
        return <img alt="26" src={mob26} />
      }

      else if (index === 27) {
        if (width > 700)
          return <img alt="27" src={mul27} />
        return <img alt="27" src={mob27} />
      }

      else if (index === 28) {
        if (width > 700)
          return <img alt="28" src={mul28} />
        return <img alt="28" src={mob28} />
      }

      else if (index === 29) {
        if (width > 700)
          return <img alt="29" src={mul29} />
        return <img alt="29" src={mob29} />
      }

      else if (index === 30) {
        if (width > 700)
          return <img alt="30" src={mul30} />
        return <img alt="30" src={mob30} />
      }

      else if (index === 31) {
        if (width > 700)
          return <img alt="31" src={mul31} />
        return <img alt="31" src={mob31} />
      }

      else if (index === 32) {
        if (width > 700)
          return <img alt="32" src={mul32} />
        return <img alt="32" src={mob32} />
      }

      else if (index === 33) {
        if (width > 700)
          return <img alt="33" src={mul33} />
        return <img alt="33" src={mob33} />
      }

      else if (index === 34) {
        if (width > 700)
          return <img alt="34" src={mul34} />
        return <img alt="34" src={mob34} />
      }

      else if (index === 35) {
        if (width > 700)
          return <img alt="35" src={mul35} />
        return <img alt="35" src={mob35} />
      }

      else if (index === 36) {
        if (width > 700)
          return <img alt="36" src={mul36} />
        return <img alt="36" src={mob36} />
      }

      else if (index === 37) {
        if (width > 700)
          return <img alt="37" src={mul37} />
        return <img alt="37" src={mob37} />
      }

      else if (index === 38) {
        if (width > 700)
          return <img alt="38" src={mul38} />
        return <img alt="38" src={mob38} />
      }

   
      else if (index === 39) {
        if (width > 700)
          return <img alt="39" src={mul39} />
        return <img alt="39" src={mob39} />
      }

      else if (index === 40) {
        if (width > 700)
          return <img alt="40" src={mul40} />
        return <img alt="40" src={mob40} />
      }

      
      else if (index === 41) {
        if (width > 700)
          return <img alt="41" src={mul41} />
        return <img alt="41" src={mob41} />
      }

      else if (index === 42) {
        if (width > 700)
          return <img alt="42" src={mul42} />
        return <img alt="42" src={mob42} />
      }

      else if (index === 43) {
        if (width > 700)
          return <img alt="43" src={mul43} />
        return <img alt="43" src={mob43} />
      }


      else if (index === 44) {
        if (width > 700)
          return <img alt="44" src={mul44} />
        return <img alt="44" src={mob44} />
      }

      else if (index === 45) {
        if (width > 700)
          return <img alt="45" src={mul45} />
        return <img alt="45" src={mob45} />
      }

      else if (index === 46) {
        if (width > 700)
          return <img alt="46" src={mul46} />
        return <img alt="46" src={mob46} />
      }

      else if (index === 47) {
        if (width > 700)
          return <img alt="47" src={mul47} />
        return <img alt="47" src={mob47} />
      }


      else if (index === 48) {
        if (width > 700)
          return <img alt="48" src={mul48} />
        return <img alt="48" src={mob48} />
      }

      else if (index === 49) {
        if (width > 700)
          return <img alt="49" src={mul49} />
        return <img alt="49" src={mob49} />
      }

      else if (index === 50) {
        if (width > 700)
          return <img alt="50" src={mul50} />
        return <img alt="50" src={mob50} />
      }

      else if (index === 51) {
        if (width > 700)
          return <img alt="51" src={mul51} />
        return <img alt="51" src={mob51} />
      }

      else if (index === 52) {
        if (width > 700)
          return <img alt="52" src={mul52} />
        return <img alt="52" src={mob52} />
      }
      
      else if (index === 53) {
        if (width > 700)
          return <img alt="53" src={mul53} />
        return <img alt="53" src={mob53} />
      }
      
    }
    return (
      <div className="main">
        {returnImg(Number(article.index))}
        <div className="centro">
          <div className="infoCurso">
            <div className="miding">
              {article.local.length === 0 ? null : (
                <div className="course-description">
                  <div className="courseInfo">
                    <div className="courseInfo-item"  >
                      <i className="infoIcon clock"></i>
                      <strong className="courseInfo-text">Duração: <span className="courseInfo-font">{article.duringTime}</span></strong>
                    </div>
                    <div className="courseInfo-item">
                      <i className="infoIcon modality"></i>
                      <strong className="courseInfo-text">Modalidade: <span className="courseInfo-font">{article.modality}</span></strong>
                    </div>
                    <div className="courseInfo-item">
                      <i className="infoIcon disponibility"></i>
                      <strong className="courseInfo-text">Disponibilidade:  <span className="courseInfo-font">{article.disponibility}</span></strong>
                    </div>

                    <div className="buyNow" style={{margin: '0px 180px' , marginTop: '-60px'}}>
                {this.buttonRender( article.disponibility, url )}
              </div>

                  </div>
                  {/* Renderiza o componente que redireciona para a compra */}
                  {/* <div className="buyNow">
                    {this.buttonRender( article.disponibility, url )}
                  </div> */}
                </div>
              )}
              {/**
                * Essse bloco é relacionado ao custo do curso e foi removido
                * em: 18/08/2020
                */}
              {/* {article.value.length === 0 ? null : (
                <div className="block" style={{ float: "left" }}>
                  <i className="fas fa-dollar-sign" style={{ color: "#fff", marginRight: "10px" }}></i><strong>INVESTIMENTO R$ {article.value}</strong>
                </div>
              )} */}
            </div>
            {/* <img src="fundo.jpg" width="auto" height="250"></img> */}
            {/* {article.about.length === 0 ? null : (
              <div className="descript">
                <h4>DESCRIÇÃO</h4>
                <p>
                  <span dangerouslySetInnerHTML={{ __html: article.about }} />
                </p>
              </div>
            )} */}
            {/* Conteúdo */}
            {article.live === "" ? null : (
              <React.Fragment>
                <br/>
                <h4>SOBRE O EVENTO</h4>
                <p className="content-p">
                  <ul>
                  {
                    article.live.map((item) => {
                      if (item === "-") {
                        return <br></br>
                      } if (item === "=") {
                        return <br></br>
                      }
                      else {
                        if (item.charAt( 0 ) !== '-') {
                          return (
                            <p className="content-p" key={item}>
                              {item}
                            </p>
                          )
                        }
                          else {
                            return (
                              <p className="content-p" key={item} style={{ marginLeft:'15px' }}>
                                {item}
                              </p>
                            )
                          }
                      }

                    })}
                </ul>
                </p>
              </React.Fragment>
            )}
            {article.content === 0 ? null : (
              <div className="content" style={{padding: "10px"}}>
                <h4>DESCRIÇÃO</h4>
                <ul>
                  {
                    article.content.map((item) => {
                      if (item === "-") {
                        return <br></br>
                      } if (item === "=") {
                        return <br></br>
                      }
                      else {
                        if (item.charAt( 0 ) !== '-') {
                          return (
                            <p className="content-p" key={item}>
                              {item}
                            </p>
                          )
                        }
                          else {
                            return (
                              <p className="content-p" key={item} style={{ marginLeft:'15px' }}>
                                {item}
                              </p>
                            )
                          }
                      }

                    })}
                </ul>
              </div>
            )}
            {/* Requisitos:
                  - Ajustar de modo que:
                    Caso haja requisitos, pensar na melhor forma de exibir.
            */}
            {article.requirements === 0 ? null : (
              <div className="content">
                <h4>PRÉ-REQUISITOS</h4>
                <ul>
                  {
                    article.requirements.map((item) => {
                      if (item === "-") {
                        return <br></br>
                      } if (item === "=") {
                        return <br></br>
                      }
                      else {
                        return <p className="content-p" key={item}>{item}</p>
                      }
                    })}
                </ul>
              </div>
            )}
             {/* ESTE CURSO INCLUI */}
             {article.content === 0 ? null : (
              <div className="content">
                <h4>ESTE CURSO INCLUI</h4>
                <ul>
                  {
                    article.include.map((item) => {
                      if (item === "-") {
                        return <br></br>
                      } if (item === "=") {
                        return <br></br>
                      }
                      else {
                        return <p className="content-p" key={item}>{item}</p>
                      }

                    })}
                        <div className="buyNow" style={{marginLeft:'-230px'}}>
                {this.buttonRender( article.disponibility, url )}
              </div>
                </ul>
              
              </div>
            )}
            
          </div>
          {/* <div className="buyNow" style={{padding:'2280px 0px 20px 0px', marginLeft:'-640px'}}>
                {this.buttonRender( article.disponibility, url )}
              </div> */}

          {article.teacher.length === 0 ? null : (
            <div className="techerCurso" >
              {/*
                Inserção do vídeo
              */}
              {/* <video width="280" height="200" controls="controls" data-reactid=".0.1.0.0">
                <source src={this.selectVideo(this.theArticle.index)}  data-reactid=".0.1.0.0" />
              </video> */}
             {this.selectVideo(this.theArticle.index) == null ? null :(
              <iframe 
              style={{padding: "10px"}}
              width="280"
              height="200" 
              src={this.selectVideo(this.theArticle.index)}
              title="YouTube video player" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; erypted-media;nc gyroscope; picture-in-picture" 
              allowfullscreen></iframe>
              )}
              {/*
                Renderiza o componente que redireciona para a compra
              */}
              {/* <div className="buyNow">
                {this.buttonRender( article.disponibility, url )}
              </div> */}
              {/*
                Componente anterior
              */}
              {/* <div className="buyNow">
                <a href={url}><strong>COMPRE AGORA</strong></a>
              </div> */}
              <img alt="img" src={teacherImg}/>
              <div className="grads">
                <h4><spin>PROFESSOR:</spin> {article.teacher} </h4>
              </div>
              <ul className="listTeacher">
                <li> CEO SUMMIT-BRA.</li>
                <li> Mestre em Ciência da Computação pela UFSCar.</li>
                <li> MBA em Gestão de TI na Fundação Getúlio Vargas.</li>
                <li> Pós-graduado em Administração com ênfase em Análise de Sistemas pela parceria IBM / IME.</li>
                <li> Certificados diversos em TI (ORACLE, OMG BPM, TOGAF).</li>
                <li> 18 anos de experiência como docente, atuando como professor em cursos na graduação e pós-graduação de diversas universidades.</li>
                <li> 18 anos de atuação em departamentos de TI de empresas diversas, com experiência nacional e internacional.</li>
              </ul>
            </div>
          )}
        </div>
      </div>

    )
  }



  onChange = date => this.setState({ date })

  renderBackButton() {
    let url = "/workshop"
    const selectedCourse = this.state.selectedCourse.split('?')
    const isSchedule = selectedCourse[1] === 'schedule' ? true : false

    if (isSchedule) {
      url = "/schedule"
    }

    return (
      <a href={url} className="back"><i className="fa fa-chevron-left"></i> Voltar</a>
    )
  }
  _onReady(event) {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }
  render() {
    this.getArticle()

    const article = this.theArticle

    return (
      <div>
        <div id="workshop-page">
          <div className="squad">
            {/* {this.renderVideo(article)} */}
            {this.renderArticle(article)}

          </div>
        </div>
        <div class="contact-simplefooter">
          <div class="footer-father">
            <Simplefooter />
          </div>
        </div>
      </div>
    )
  }

  componentDidMount() {
    window.scroll(0, 0)
  }
}



// WEBPACK FOOTER //
// ./src/components/workshop/workshop-page.js